import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./success.svg?react";

export const SuccessIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
